import React from "react";

const SliderIndicators = ({ count = 2, activeIndex = 0, accentColor = "#C78D3C", onClick }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", marginTop: "30px" }}>
      {[...Array(count)].map((_, i) => {
        const isActive = i === activeIndex;
        if (isActive) {
          return (
            <svg key={i} onClick={() => onClick && onClick(i)} style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width="28" height="14" viewBox="0 0 28 14" fill="none">
              <path d="M21 0C24.866 0 28 3.13401 28 7C28 10.866 24.866 14 21 14H7C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0H21Z" fill={accentColor}/>
            </svg>
          );
        }
        return (
          <svg key={i} onClick={() => onClick && onClick(i)} style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle opacity="0.2" cx="7" cy="7" r="7" fill="black"/>
          </svg>
        );
      })}
    </div>
  );
};

export { SliderIndicators };
